import { render, staticRenderFns } from "./LastMatches.vue?vue&type=template&id=63794d84&scoped=true&"
import script from "./LastMatches.vue?vue&type=script&lang=js&"
export * from "./LastMatches.vue?vue&type=script&lang=js&"
import style0 from "./LastMatches.vue?vue&type=style&index=0&id=63794d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63794d84",
  null
  
)

export default component.exports